import { AxiosResponse } from 'axios'
import {
    NoteResponse,
    CreateNewNoteType,
    UpdateNoteType,
    DeleteNoteType,
} from '../../models/Note'
import { axiosWithImitator } from '../withAuth'

export type NoteTypes = 'MedlemIdent' | 'ArbejdsstedNr'

export type getNotesReponse = {
    Noter: NoteResponse[]
    AntalIalt: number
}

const getMemberNotes = async (
    id: number,
    type: NoteTypes
): Promise<getNotesReponse> => {
    const response = await axiosWithImitator.get(`/note/hentnoter`, {
        params: {
            'request.referenceId': id,
            'request.referenceType': type,
        },
    })

    const { data } = response
    return data
}

// /note/hentbrugersnoter
const getAllNotes = async (type = 'MedlemIdent'): Promise<any> => {
    const response = await axiosWithImitator.get(`/note/hentbrugersnoter`, {
        params: {
            'request.referenceType': type,
        },
    })
    return response
}

const addNewNote = async (
    values: CreateNewNoteType
): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.post(`/note/opretnote`, values)

    return response
}

const updateNote = async (values: UpdateNoteType): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.post(`/note/opdaternote`, values)

    return response
}

const updateNoteIsArchived = async (
    id: number,
    isRead: boolean
): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.post(
        `/note/opdaternoteerlaest`,
        null,
        {
            params: {
                'request.noteId': id,
                'request.erLaest': isRead,
            },
        }
    )

    return response
}

const deleteNote = async (id: number): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.delete(`/note/sletnote`, {
        params: {
            'request.noteId': id,
        },
    })

    return response
}

export {
    getMemberNotes,
    addNewNote,
    updateNote,
    deleteNote,
    getAllNotes,
    updateNoteIsArchived,
}
